/**
 * Daily Focus Immersion Page
 * Standalone route for the focus light meditation
 */

import { useNavigate } from "react-router-dom";
import FocusImmersion from "../../components/FocusImmersion";

const DailyFocusPage = () => {
  const navigate = useNavigate();

  return (
    <FocusImmersion
      durationMinutes={5}
      onComplete={() => navigate(-1)}
      onClose={() => navigate(-1)}
    />
  );
};

export default DailyFocusPage;
